<!-- =========================================================================================
    File Name: Recommend.vue
    Description: Price Optimization Recommendation
    ----------------------------------------------------------------------------------------
    Item Name: Appyvue - Bootstrap App with PY and VUE
    Author: @nand
========================================================================================== -->
<template>
  <div id="analyze-item-list" v-if="['SDF'].includes(artefact.type)">
    <!-- <pre>{{trendUnit}}</pre> -->
    <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <div class="vx-row" v-if="showContainer.category">
      <div class="vx-col w-full mb-base">
          <vx-card :title="artefact.type === 'SDF' ? 'Category level Forecast' : 'Forecast'">
            <template slot="actions">
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  v-if="units.category.data.length > 0"
                  :svgClasses="[{'text-success stroke-current': units.category.data.length > 0}, 'w-5', 'h-5 mr-4']"
                  @click.stop="exportData('category')" />

                <feather-icon
                  icon="FilterIcon"
                  class="cursor-pointer"
                  :svgClasses="[{'text-success stroke-current': filter.apply}, {'text-danger stroke-current': !filter.apply}, 'w-5', 'h-5 mr-4']"
                  @click.stop="switchFilter" />

                <feather-icon
                  icon="RefreshCcwIcon"
                  class="cursor-pointer"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="resetFilter"
                  v-if="filter.apply"
                  />
              </div>
            </template>
            <vs-table pagination max-items="10" search :data="units.category.data">

              <template slot="thead">
                <vs-th>Sl. No.</vs-th>
                <vs-th sort-key="long_description" v-if="showCol('category', 'long_description')">SKU Desc</vs-th>
                <vs-th sort-key="brand" v-if="showCol('category', 'brand')">Brand</vs-th>
                <vs-th sort-key="product_category" v-if="showCol('category', 'product_category')">Category / Sub Category</vs-th>
                <vs-th sort-key="quantity" v-if="showCol('category', 'quantity')">Forecast Units</vs-th>
                <vs-th sort-key="revenue_sum" v-if="showCol('category', 'revenue_sum')">Forecast Sales</vs-th>
                <vs-th sort-key="type" v-if="showCol('category', 'level')">Category Level</vs-th>
                <vs-th>Brand / SKU / Trend</vs-th>
              </template>

              <template slot-scope="{data}">
                <!-- <vs-tr :state="data[indextr].type == 'fast' ? 'success': data[indextr].type == 'slow' ? 'danger': null" :data="tr" :key="indextr" v-for="(tr, indextr) in data"> -->
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                  <vs-td :data="data[indextr].long_description" v-if="showCol('category', 'long_description')">
                    {{ data[indextr].long_description }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small>
                  </vs-td>

                  <vs-td :data="data[indextr].brand" v-if="showCol('category', 'brand')">
                    {{ data[indextr].brand }}
                  </vs-td>

                  <vs-td :data="data[indextr].product_category" v-if="showCol('category', 'product_category')">
                    <vs-breadcrumb>
                      <!-- <li><vs-avatar size="small" :badge-color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')" :badge="data[indextr].level" :text="data[indextr].type" /></li> -->
                      <li @click="applyFilter('category', 'product_category', false, 1, data[indextr])" class="text-dark" v-if="filter.apply && data[indextr].level< 4 && (data[indextr].level === filter['category'].level)">+{{ data[indextr].product_category }}</li>
                      <li @click="applyFilter('category', 'product_category', false, -1, data[indextr])" class="font-bold text-dark" v-if="(filter.apply && data[indextr].level< 4 && (data[indextr].level !== filter['category'].level))">-{{ data[indextr].product_category }}</li>
                      <li @click="applyFilter('category', 'product_category', false, -1, data[indextr])" class="text-grey" v-if="(filter.apply && data[indextr].level> 3 && (data[indextr].level === filter['category'].level))">-{{ data[indextr].product_category }}</li>
                      <li class="text-gray" v-if="!filter.apply">{{ data[indextr].product_category }}</li>
                      <!-- <feather-icon
                        icon="FilterIcon"
                        svgClasses="ml-3 w-4 h-4 text-grey"
                        @click="openContainer('sku', 'product_category', true, 0, data[indextr])"
                      ></feather-icon> -->
                    </vs-breadcrumb>

                    <!-- <feather-icon
                      icon="CornerUpLeftIcon"
                      svgClasses="ml-3 w-4 h-4 text-grey"
                      @click="applyFilter('category', 'product_category', false, -1, data[indextr])"
                      v-show="filter.apply && data[indextr].level > 1"
                    ></feather-icon> -->
                    <!-- <feather-icon
                      icon="FilterIcon"
                      svgClasses="ml-3 w-4 h-4 text-grey"
                      @click="applyFilter('category', 'product_category', false, 1, data[indextr])"
                      v-show="filter.apply && data[indextr].level< 4 && (data[indextr].level === filter['category'].level)"
                    ></feather-icon> -->
                  </vs-td>

                  <vs-td align="right" :data="data[indextr].quantity" v-if="showCol('category', 'quantity')">
                    <!-- {{ data[indextr].revenue_sum | numFormat('0.00') }} -->
                    <span>{{ data[indextr].quantity | numFormat('0') }}</span>
                    <vs-progress :percent="(data[indextr].quantity / (units.category.upd))*100" :color="data[indextr].quantity > 0 ? 'success' : 'warning'"></vs-progress>
                  </vs-td>

                  <vs-td align="right" :data="data[indextr].revenue_sum" v-if="showCol('category', 'revenue_sum')">
                    <!-- {{ data[indextr].quantity | numFormat('0.00') }} -->
                    <span>{{ data[indextr].revenue_sum | numFormat('$ 0') }}</span>
                    <vs-progress :percent="(data[indextr].revenue_sum / (units.category.rpd))*100" :color="data[indextr].revenue_sum > 0 ? 'success' : 'warning'"></vs-progress>
                  </vs-td>

                  <vs-td :data="data[indextr].type" v-if="showCol('category', 'type')">
                    <!-- <vs-avatar :badge-color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')" :badge="data[indextr].level" :text="data[indextr].type" /> -->
                    <!-- <vs-chip :color="data[indextr].quantity > 0 ? 'success' : 'warning'">{{data[indextr].quantity > 0 ? 'high' : 'low'}}</vs-chip> -->
                    <vs-chip class="ml-2">level {{data[indextr].level}}</vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].type" v-if="showCol('category', 'type')">
                    <feather-icon
                      icon="TagIcon"
                      svgClasses="ml-3 w-6 h-6 text-grey"
                      @click="openContainer('brand', 'product_category', true, 1, data[indextr])"
                    ></feather-icon>
                    <feather-icon
                      icon="LayersIcon"
                      svgClasses="ml-3 w-6 h-6 text-grey"
                      @click="openContainer('sku', 'product_category', true, 1, data[indextr])"
                    ></feather-icon>
                    <feather-icon
                      icon="BarChart2Icon"
                      svgClasses="ml-3 w-6 h-6 text-grey"
                      @click="showTrend('categoryTrend', data[indextr])"
                    ></feather-icon>
                    <!-- <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-filter" @click="openContainer('sku', 'product_category', true, 1, data[indextr])">Brands</vs-button>
                    <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-filter" @click="openContainer('sku', 'product_category', true, 1, data[indextr])">SKUs</vs-button> -->
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
      </div>
    </div>
    <div class="vx-row" v-if="showContainer.brand">
      <div class="vx-col w-full mb-base">
          <vx-card :title="artefact.type === 'SDF' ? 'Brand level split of Category Demand' : 'Brands of Category'">
            <template slot="actions">
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  v-if="units.sku.data.length > 0"
                  :svgClasses="[{'text-success stroke-current': units.sku.data.length > 0}, 'w-5', 'h-5 mr-4']"
                  @click.stop="exportData('brand')" />

                <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  v-if="type === 'category'"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideContainer('category')"
                  />

              </div>

              <!-- <vs-button @click="activePrompt=true">Export</vs-button> -->
            </template>
            <vs-table pagination max-items="10" search :data="units.brand.data">

              <template slot="thead">
                <vs-th>Sl. No.</vs-th>
                <vs-th sort-key="long_description" v-if="showCol('brand', 'long_description')">SKU Desc</vs-th>
                <vs-th sort-key="brand" v-if="showCol('brand', 'brand')">Brand</vs-th>
                <vs-th sort-key="cat_lookup" v-if="showCol('brand', 'cat_lookup')">Category / Sub Category</vs-th>
                <vs-th sort-key="quantity" v-if="showCol('brand', 'quantity')">Forecast Units</vs-th>
                <vs-th sort-key="revenue_sum" v-if="showCol('brand', 'revenue_sum')">Forecast Sales</vs-th>
                <vs-th sort-key="type" v-if="showCol('brand', 'type')">Priority</vs-th>
                <vs-th>Details</vs-th>
              </template>

              <template slot-scope="{data}">
                <!-- <vs-tr :state="data[indextr].type == 'fast' ? 'success': data[indextr].type == 'slow' ? 'danger': null" :data="tr" :key="indextr" v-for="(tr, indextr) in data"> -->
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                  <vs-td :data="data[indextr].long_description" v-if="showCol('brand', 'long_description')">
                    {{ data[indextr].long_description }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small>
                  </vs-td>

                  <vs-td :data="data[indextr].brand" v-if="showCol('brand', 'brand')">
                    {{ data[indextr].brand }}
                  </vs-td>

                  <vs-td :data="data[indextr].cat_lookup" v-if="showCol('brand', 'cat_lookup')">
                      {{ data[indextr].cat_lookup }}
                  </vs-td>

                  <vs-td align="right" :data="data[indextr].quantity" v-if="showCol('brand', 'quantity')">
                    <!-- {{ data[indextr].quantity | numFormat('0.00') }} -->
                    <span>{{ data[indextr].quantity | numFormat('0') }}</span>
                    <vs-progress :percent="(data[indextr].quantity / (units.brand.upd))*100" :color="data[indextr].quantity > 0 ? 'success' : 'warning'"></vs-progress>
                  </vs-td>

                  <vs-td align="right" :data="data[indextr].revenue_sum" v-if="showCol('brand', 'revenue_sum')">
                    <!-- {{ data[indextr].revenue_sum | numFormat('0.00') }} -->
                    <span>{{ data[indextr].revenue_sum | numFormat('$ 0') }}</span>
                    <vs-progress :percent="(data[indextr].revenue_sum / (units.brand.rpd))*100" :color="data[indextr].revenue_sum > 0 ? 'success' : 'warning'"></vs-progress>
                  </vs-td>

                  <vs-td :data="data[indextr].type" v-if="showCol('brand', 'type')">
                    <!-- <vs-avatar :badge-color="data[indextr].type === 'fast' ? 'success' : (data[indextr].type === 'slow' ? 'danger' : 'warning')" :badge="data[indextr].level" :text="data[indextr].type" /> -->
                    <vs-chip :color="data[indextr].quantity > 0 ? 'success' : 'warning'">{{data[indextr].quantity > 0 ? 'high' : 'low'}}</vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].type" v-if="showCol('brand', 'type')">
                    <!-- <feather-icon
                      icon="LayersIcon"
                      svgClasses="ml-3 w-6 h-6 text-grey"
                      @click="openContainer('sku', 'product_category', true, 1, data[indextr])"
                      v-show="filter.apply && data[indextr].level< 4 && (data[indextr].level === filter['category'].level)"
                    ></feather-icon> -->
                    <!-- <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-filter" @click="openContainer('sku', 'product_category', true, 1, data[indextr])">Brands</vs-button> -->
                    <vs-button size="small" color="primary" type="filled" icon-pack="feather" icon="icon-filter" @click="openContainer('sku', 'brand,product_category', true, 1, data[indextr], 'eq,sw')">SKUs</vs-button>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
      </div>
    </div>
    <div class="vx-row" v-if="showContainer.sku">
      <div class="vx-col w-full mb-base">
          <vx-card :title="artefact.type === 'SDF' ? 'SKUs Level Forecast by '+ (artefact.mode === 'revenue' ? 'Sales ( '+this.$options.filters.currencySymbol('')+' )' : 'Quantity') : 'SKUs Level Forecast'">
            <template slot="actions">
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  v-if="units.sku.data.length > 0"
                  :svgClasses="[{'text-success stroke-current': units.sku.data.length > 0}, 'w-5', 'h-5 mr-4']"
                  @click.stop="exportData('sku')" />

                <feather-icon
                  icon="XCircleIcon"
                  class="cursor-pointer"
                  v-if="type === 'category'"
                  :svgClasses="['w-5', 'h-5 mr-4']"
                  @click.stop="hideContainer('brand')"
                  />

              </div>

              <!-- <vs-button @click="activePrompt=true">Export</vs-button> -->
            </template>
            <vs-table pagination max-items="10" search :data="units.sku.data">

              <template slot="thead">
                <vs-th></vs-th>
                <vs-th sort-key="desc" v-if="showCol('sku', 'desc')">SKU Desc</vs-th>
                <vs-th sort-key="product_category" v-if="showCol('sku', 'product_category')">Category / Sub Category</vs-th>
                <vs-th sort-key="brand" v-if="showCol('sku', 'brand')">Brand</vs-th>
                <vs-th sort-key="quantity" v-if="showCol('sku', 'quantity')">Units</vs-th>
                <!-- <vs-th sort-key="revenue_sum" v-if="showCol('category', 'revenue_sum')">$ Sales</vs-th> -->
                <vs-th sort-key="revenue_sum">Forecast Sales ( {{ '' | currencySymbol }} )</vs-th>
                <vs-th sort-key="inventory">Inventory</vs-th>
                <vs-th>Show Trend</vs-th>
                <vs-th sort-key="is_alert" v-if="showCol('sku', 'is_alert')">Alert</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>

                  <vs-td :data="data[indextr].desc" v-if="showCol('sku', 'desc')">
                    {{ data[indextr].desc | ellipsis(50) }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small>
                  </vs-td>

                  <vs-td :data="data[indextr].cat_lookup" v-if="showCol('sku', 'product_category')">
                    {{ data[indextr].cat_lookup }}
                  </vs-td>

                  <vs-td :data="data[indextr].brand" v-if="showCol('sku', 'brand')">
                    {{ data[indextr].brand }}
                  </vs-td>

                  <vs-td align="right" :data="data[indextr].quantity" v-if="showCol('sku', 'quantity')">
                    <!-- {{ data[indextr].quantity | numFormat('0.00') }} -->
                    <span>{{ data[indextr].quantity | numFormat('0') }}</span>
                    <vs-progress :percent="(data[indextr].quantity / (units.sku.upd))*100" :color="data[indextr].quantity > 0 ? 'success' : 'warning'"></vs-progress>
                  </vs-td>
                  
                  <vs-td align="right" :data="data[indextr].revenue_sum" v-if="showCol('sku', 'revenue_sum')">
                    <span>{{ data[indextr].revenue_sum | numFormat('$ 0') }}</span>
                    <vs-progress :percent="(data[indextr].revenue_sum / (units.sku.rpd))*100" :color="data[indextr].revenue_sum > 0 ? 'success' : 'warning'"></vs-progress>
                  </vs-td>

                  <!-- <vs-td :data="data[indextr].ctc">
                    {{ '~' | numFormat }}
                  </vs-td> -->

                  <vs-td :data="data[indextr].stock_qty">
                    {{ data[indextr].stock_qty | numFormat }}
                  </vs-td>

                  <!-- <vs-td :data="data[indextr].type" v-if="showCol('sku', 'type')">
                    <vs-chip :color="data[indextr].quantity > 0 ? 'success' : 'warning'">{{data[indextr].quantity > 0 ? 'high' : 'low'}}</vs-chip>
                  </vs-td> -->

                  <vs-td :data="data[indextr].is_alert" v-if="showCol('sku', 'is_alert')">
                    <feather-icon icon="AlertTriangleIcon" svgClasses="w-6 h-6 text-danger" v-if="data[indextr].is_alert === 1"></feather-icon>
                  </vs-td>

                  <feather-icon
                    icon="BarChart2Icon"
                    svgClasses="ml-3 w-6 h-6 text-grey"
                    @click="showTrend('skuTrend', data[indextr])"
                  ></feather-icon>

                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
      </div>
    </div>
    <div class="vx-row" v-if="showContainer.skuTrend">
      <div class="vx-col w-full">
        <vx-card :title="'Sale Trend - SKU-'+ trendUnit.sku_id + ' ( ' +this.$options.filters.ellipsis(trendUnit.desc, 100) +' )'" subtitle="Actual and Forecast Sale by Week in Quantity & $ Sales">
          <template slot="actions">
            <feather-icon
              icon="XCircleIcon"
              class="cursor-pointer"
              v-if="type === 'category'"
              :svgClasses="['w-5', 'h-5 mr-4']"
              @click.stop="hideContainer('sku')"
              />
          </template>
          <!-- <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="355"
              :options="chart.chartOptions"
              :series="chart.series"
            />
          </div> -->
          <dem-for-trend-sku :artefact="artefact" :key="artefact.type+'-1'" type="sku" :data="trendUnit"></dem-for-trend-sku>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" v-if="showContainer.categoryTrend">
      <div class="vx-col w-full">
        <vx-card :title="'Category level Sale Trend ( Actual Vs Forecast ) - '+ trendUnit.product_category" subtitle="Actual and Forecast Sale by Week in Quantity & $ Sales">
          <template slot="actions">
            <feather-icon
              icon="XCircleIcon"
              class="cursor-pointer"
              v-if="type === 'category'"
              :svgClasses="['w-5', 'h-5 mr-4']"
              @click.stop="hideContainer('category')"
              />
          </template>
          <demfor-cat></demfor-cat>
          <!-- <dem-for-trend-sku :artefact="artefact" :key="artefact.type+'-1'" type="category" :data="trendUnit"></dem-for-trend-sku> -->
          <!-- <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="355"
              :options="chart.chartOptions"
              :series="chart.series"
            />
          </div> -->
        </vx-card>
      </div>
    </div>    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vSelect from 'vue-select';
import VueApexCharts from "vue-apexcharts";

import DemforCat from "./DemforCat.vue";
import { appCommons } from "@/app/shared/services";
import {fetchMock} from "../shared/services";
import appConfig from "@/../appConfig.js";

const chartColors = appConfig.chart.colors;

export default {
  props: {
    artefact: { type: Object, required: true },
    type: { type: String, required: true }
  },
  data() {
    return {
      showStatsPanel: true,
      popupActive: false,
      colorx:"#e1e1e1",

      showContainer: {
        category: true,
        brand: false,
        sku: false,
        skuTrend: false,
        categoryTrend: false,
      },
      unitSelected: {},
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      units: {
        category: {
          upd: 1.0,
          rpd: 1.0,
          headers: [],
          data: []
        },
        brand: {
          upd: 1.0,
          rpd: 1.0,
          headers: [],
          data: []
        },
        sku: {
          upd: 1.0,
          rpd: 1.0,
          headers: [],
          data: []
        },
      },
      filter: {
        apply: true,
        category: {
          active: true,
          level: 1,
          flat: false,
          rule: []
        },
        brand: {
          active: false,
          level: 1,
          flat: true,
          rule: []
        },
        sku: {
          active: false,
          level: 1,
          flat: true,
          rule: []
        }
      },
      stores: {
          "ccb23788-2d92-11e1-8194-0015c5e16c09": "Cagueuyes",
          "ccb2363e-2d92-11e1-8194-0015c5e16c09": "Paradise ",
          "cc91c7e6-2d92-11e1-8194-0015c5e16c09": "Palero"
      },
      trendUnit: {},

      fileName: "",
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      header: {
        category: {
          title: ["Sl. No.", "Category", "Level", "Units / Day", "$ Sales"],
          value: ["row", "product_category", "level", "quantity", "revenue_sum"]
        },
        brand: {
          title: ["Sl. No.", "Brand", "Category", "Units / Day", "$ Sales"],
          value: ["row", "brand", "cat_lookup", "quantity", "revenue_sum"]
        },
        sku: {
          title: ["Sl. No.", "SKU Id", "Desc", "Category", "Brand", "Units / Day"],
          value: ["row", "sku_id", "desc", "product_category", "brand", "quantity"]
        }
      },
      activePrompt: false,
      exportType: null,

      payload: {
        tags: [],
        dateRange: {},
        query: "",
        mode: "",
        type: "",
      },


      trendLineChart: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          // annotations: {
          //   xaxis: [
          //     {
          //       // in a datetime series, the x value should be a timestamp, just like it is generated below
          //       x: new Date("19 Apr 2020").getTime(),
          //       strokeDashArray: 0,
          //       borderColor: "#FEB019",
          //       label: {
          //         borderColor: "#FEB019",
          //         style: {
          //           color: "#fff",
          //           background: "#FEB019"
          //         },
          //         // text: "Demand"
          //       }
          //     },
          //     {
          //       x: new Date("12 Apr 2020").getTime(),
          //       // x2: new Date("19 Apr 2020").getTime(),
          //       borderColor: "#FEB019",
          //       fillColor: '#FEB019',
          //       label: {
          //         borderColor: "#FEB019",
          //         style: {
          //           color: "#fff",
          //           background: "#FEB019"
          //         },
          //         // orientation: "horizontal",
          //         text: "Forecast Week"
          //       }
          //     }
          //   ],
          //   points: [
          //     {
          //       x: new Date("19 Apr 2020").getTime(),
          //       // y: 10000,
          //       marker: {
          //         size: 6,
          //         fillColor: "#fff",
          //         strokeColor: "#2698FF",
          //         radius: 2
          //       },
          //       label: {
          //         borderColor: "#FF4560",
          //         offsetY: 0,
          //         style: {
          //           color: "#fff",
          //           background: "#FF4560"
          //         },

          //         // text: "Forecast Week...."
          //       }
          //     }
          //   ]
          // },
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 4, 0, 4, 0, 4],
            width: [2, 2, 2, 2, 2, 2]
          },
          grid: {
            borderColor: "#e7e7e7"
          },
          legend: {
            show: false
          },
          colors: chartColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: chartColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 15,
            title: {
              offsetY: 10,
              text: "Week"
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
            // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
            // categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
            // categories:[],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            title: {
              text: "Quantity",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            },
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return (val > 999 || val < -999)
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            }
          },
          tooltip: {
            shared: true,
            intersect: false
            // x: { show: false }
          }
        }
      }

    };
  },
  watch: {},
  computed: {
    chart() {
      return this.trendLineChart;
    },
    // ...mapGetters({artefact: "senser/artefact", isLoading: "senser/isLoading"})
  },
  methods: {
    init(){
      this.fetchUnits('category');
      this.fetchUnits('brand');
      // this.fetchUnits('sku');

      this.switchContainer(this.type);
    },
    fetchUnits(type) {
      this.units[type].data = this.formatItemsData(type);
      if(this.units[type] && this.units[type].data.length > 0) {
        // this.units[type].upd = this.units[type].data.reduce(function(prev, cur) {
        //   if(cur.level === 1) {
        //     return prev + cur.quantity;
        //   } else {
        //     return prev;
        //   }
        // }, 0);
        this.units[type].upd = this.units[type].data[0].quantity;
        this.units[type].rpd = this.units[type].data[0].revenue_sum;
        this.units[type].headers = Object.keys(this.units[type].data[0]);
      }
    },
    formatItemsData(type) {
      let units = this.filterAndSortData(this.artefact.type, this.artefact.mock.demand[type], type);

      if(this.artefact.type === 'SFM' || this.artefact.type === 'SDF') {
        units.reverse();
      }
      if(units.length > 0) {
        for(var i = 0; i < units.length; i++) {
          units[i].row = i+1;
        }
      }

      return units;
    },
    filterAndSortData(rtype, data, dtype) {

      let filteredData = data.filter(
        t => (
          ((rtype === 'SFM' && t.type === 'fast') || (rtype === 'SSM' && t.type === 'slow') || rtype === 'SDF') &&
          (this.filter.apply && !this.filter[dtype].flat && this.filter[dtype].active && this.filter[dtype] && this.filter[dtype].level ? (t.level <= (this.filter[dtype].level)) : true) &&
          ((this.filter.apply && this.filter[dtype] && this.filter[dtype].active) ? this.handleFilterRule(this.filter[dtype].rule, t) : true)
        )
      );

      return filteredData.sort(function(t1, t2) {
        var upd1 = t1.revenue_sum;
        var upd2 = t2.revenue_sum;

        var cat1 = t1.product_category;
        var cat2 = t2.product_category;

        if (upd1 < upd2) {
          return -1;
        } else if (upd1 > upd2) {
          return 1;
        } else if (cat1 < cat2) {
          return 1;
        } else if (cat1 > cat2) {
          return -1;
        }

        // tags must be equal
        return 0;
      });

    },
    handleFilterRule(rules, t) {
      let flag = false;
      if(rules && rules.length > 0) {
        for(var pos = 0; pos < rules.length; pos++) {
          let rule = rules[pos];
          if(t[rule.key]) {
            if(rule.check === 'sw'){
              flag = t[rule.key].startsWith(rule.lookup);
            } else if(rule.check === 'eq'){
              flag = t[rule.key] === rule.lookup;
            } else if(rule.check === 'ne'){
              flag = t[rule.key] !== rule.lookup;
            } else if(rule.check === 'ct'){
              flag = t[rule.key].contains(rule.lookup);
            }
            if(!flag) break;
          } else {
            flag = true;
          }
        }
      } else {
        flag = true;
      }

      return flag;
    },

    showCol(type, key) {
      return this.units[type].headers.includes(key);
    },
    switchContainer(type) {
      Object.entries(this.showContainer).forEach(([key, value]) => {
        if(type === key) {
          this.showContainer[key] = true;
        } else {
          this.showContainer[key] = false;
        }
      });
    },

    applyFilter(dtype, keys, flat, rollTo, data, ruleCheckType) {
      if(this.filter.apply) {
        this.filter.data = data;
        this.filter.rollTo = rollTo;
        this.filter.flat = flat;
        this.filter[dtype].active = true;

        this.filter[dtype].level = this.filter[dtype].level + (1 * rollTo);
        this.filter[dtype].flat = flat;
        
        this.filter[dtype].rule = [];
        let  keyArr = keys.split(",");
        let ruleCheck = ruleCheckType ? ruleCheckType.split(",")  : [];

        for(let pos = 0; pos < keyArr.length; pos++){ 
          let rule = {
            key: '',
            lookup: '',
            check: ''
          };

          let key = keyArr[pos];
          if(!flat && this.filter[dtype].level > 1) {
            var cat = data[key].split(" / ", this.filter[dtype].level-1);
            cat = cat.filter(c => c !== 'ZCat')
            rule.key = key;
            rule.lookup = cat ? cat.join(" / ") : data[key];
            rule.check = ruleCheck && ruleCheck.length > 0 ? ruleCheck[pos] : "sw";

            this.filter[dtype].rule.push(rule);

          } else if(flat) {
            var cat = data[key].split(" / ", this.filter[dtype].level+1);
            cat = cat.filter(c => c !== 'ZCat')
            rule.key = key;
            rule.lookup = cat ? cat.join(" / ") : data[key];
            rule.check = ruleCheck && ruleCheck.length > 0 ? ruleCheck[pos] : "sw";

            this.filter[dtype].rule.push(rule);
          }
        }
      }

      this.fetchUnits(dtype);
    },
    switchFilter() {
      this.filter.apply = !this.filter.apply;
      if(!this.filter.apply) {
        this.resetFilter();
      }
      this.init();
    },

    resetFilter() {
      this.filter = {
        apply: this.filter.apply,
        category: {
          active: true,
          level: 1,
          flat: false,
          rule: []
        },
        brand: {
          active: false,
          level: 1,
          flat: true,
          rule: []
        },
        sku: {
          active: false,
          level: 1,
          flat: true,
          rule: []
        }
      };

      this.init();
    },

    exportData(type) {
      this.exportType = type;
      if(this.artefact.type === "SDF") {
        this.fileName = "Demand_Forecast_by_"+type
      } else {
        this.fileName = (this.artefact.type === "SFM") ? "Demand_Forecast_by_"+type : "Demand_Forecast_by_"+type;
      }
      this.activePrompt=true;
    },

    openContainer(dtype, key, flat, rollTo, data, ruleCheckType) {
      if(dtype === 'sku') {
        this.$vs.loading({
            // background: this.backgroundLoading,
            // color: this.colorLoading,
            // container: "#exploreButton",
            // scale: 0.45,
            type: "radius"
          });
        let tag = {'tag':data.product_category,'type':'C'};
        this.payload = {
          tags: this.artefact.tags,
          dateRange: this.artefact.dateRange,
          query: this.artefact.query,
          mode: this.artefact.mode,
          type: 'SCDF'
        };

        this.payload.tags[1] = tag;
        fetchMock(this.payload)
          .then(response => {
            this.artefact.mock.demand.sku = response.data.demand.sku;
            this.fetchUnits('sku');
            this.$vs.loading.close();

            this.applyFilter(dtype, key, flat, rollTo, data, ruleCheckType);
            this.switchContainer(dtype);
          })
          .catch(error => {
            this.$vs.loading.close();
            throw new Error(error);
          });
      } else {
        this.applyFilter(dtype, key, flat, rollTo, data, ruleCheckType);
        this.switchContainer(dtype);
      }
    },
    hideContainer(dtype) {
      this.moverContainerTitle = "";
      this.trendUnit = {};
      this.switchContainer(dtype);
    },
    showTrend(container, data) {
      this.trendUnit = data;
      this.switchContainer(container);

        // this.$vs.loading({
        //     // background: this.backgroundLoading,
        //     // color: this.colorLoading,
        //     // container: "#exploreButton",
        //     // scale: 0.45,
        //     type: "radius"
        //   });
        // let tag = {'tag':data.sku_id,'type':'U'};
        // this.payload = {
        //   tags: this.artefact.tags,
        //   dateRange: this.dateScope(),
        //   query: this.artefact.query,
        //   mode: this.artefact.mode,
        //   type: 'SST'
        // };

        // this.payload.tags[1] = tag;

        // fetchMock(this.payload)
        //   .then(response => {
        //     this.trendLineChart = this.buildStatsData(response.data.trend);
        //     this.$vs.loading.close();

        //     this.switchContainer(container);
        //   })
        //   .catch(error => {
        //     this.$vs.loading.close();
        //     throw new Error(error);
        //   });
    },

    exportToExcel() {
      import('@/app/shared/vendor/Export2Excel').then(excel => {
        const list = this.units[this.exportType].data;
        const data = this.formatJson(this.header[this.exportType].value, list)
        excel.export_json_to_excel({
          header: this.header[this.exportType].title,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields() {
      this.filename = "",
      this.cellAutoWidth = true,
      this.selectedFormat = "xlsx"
    },

    // Trend related methods
    buildStatsData(trendData) {
      let series = [];
      let chartData = {};
      Object.assign(chartData, this.trendLineChart);

      for (let i = 0; i < this.artefact.tags.length; i++) {
        let filteredUnitDataTrend = {
          name: "",
          data: []
        };
        let filteredUnitDataPredict = {
          name: "",
          data: []
        };

        filteredUnitDataTrend.name = "Actual Sale";
        filteredUnitDataPredict.name = "Forecast Sale";

        let filteredActual = this.filterAndSortStatsData(
          this.artefact.tags[i],
          trendData,
          "actual"
        );

        let filteredPredict = this.filterAndSortStatsData(
          this.artefact.tags[i],
          trendData,
          "prediction"
        );

        let maxWeeksActual = filteredActual.length;
        let maxWeeksPredict = filteredPredict.length;
        if(maxWeeksActual > 0) {
          filteredUnitDataTrend.data = this.buildseriesOfStatsGroup("actual", maxWeeksActual, filteredActual, filteredActual[0].sale_year);
          series.push(filteredUnitDataTrend);
        }
        if(maxWeeksPredict > 0) {
          filteredUnitDataPredict.data = this.buildseriesOfStatsGroup("predict", maxWeeksPredict, filteredPredict, filteredPredict[0].sale_year);
          series.push(filteredUnitDataPredict);
        }
/*
        let predictionWeekStartDate = this.$moment()
            .isoWeekYear(filteredPredict[maxWeeksActual-1].sale_year)
            .isoWeek(filteredPredict[maxWeeksActual-1].sale_week)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

        let predictionWeekEndDate = this.$moment()
            .isoWeekYear(filteredPredict[maxWeeksPredict - 1].sale_year)
            .isoWeek(filteredPredict[maxWeeksPredict - 1].sale_week)
            .startOf('isoWeek')
            .format('MM-DD-YYYY'); 
            
        let predictionWeekStart = new Date(predictionWeekStartDate).getTime();
        let predictionWeekEnd = new Date(predictionWeekEndDate).getTime();            

        this.trendLineChart.chartOptions = {
          ...this.trendLineChart.chartOptions,
          annotations: {
            ...this.trendLineChart.chartOptions.annotations,
            xaxis: [
              {
                // in a datetime series, the x value should be a timestamp, just like it is generated below
                // x: predictionWeekEnd,
                x: predictionWeekStart,
                borderColor: "#2698FF",
                fillColor: '#FEB019',
                label: {
                  borderColor: "#2698FF",
                  style: {
                    color: "#fff",
                    background: "#2698FF"
                  },
                  // orientation: "horizontal",
                  text: "Forecast Week"
                }
              }
            ],
            points: [
              {
                x: predictionWeekEnd,
                // y: 15000,
                marker: {
                  size: 6,
                  fillColor: "#fff",
                  strokeColor: "#2698FF",
                  radius: 2
                },
                label: {
                  borderColor: "#FF4560",
                  offsetY: 0,
                  style: {
                    color: "#fff",
                    background: "#FF4560"
                  }

                  // text: "Forecast Week"
                }
              }
            ]
          }
        };
*/
        // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      }

      this.trendLineChart.series = series;
      // chartData.series = series;
      // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      // return chartData;
      return this.trendLineChart;
    },
    filterAndSortStatsData(tag, data, type) {
      // let filteredData = data.filter(t =>
      //   ((t.store_code
      //     ? tag.code === t.store_code
      //     : tag.tag === t.product_category) && t.type === type)
      // );

      let filteredData = data.filter(t =>
        ((t.store_code
          ? tag.code === t.store_code
          : tag.tag === t.product_category) && (type !== 'prediction' ? (t.type === type) : true))
      );

      return filteredData.sort(function(t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },

    buildseriesOfStatsGroup(type, maxWeeks, groupedUnit, startYear) {
      let series = [];
      let weekIndex = 0;
      let currentWeek = 1;
      let currentMonth = 0;
      let currentYear = startYear;
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year;

          //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + currentYear : "");

          let fieldToFetch = type+'_qty';

          let y = groupedUnit[weekIndex].revenue
            ? groupedUnit[weekIndex].revenue || 0
            : groupedUnit[weekIndex][fieldToFetch] || 0;

          series.push({
            x: x,
            y: Math.floor(y)
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(++currentYear)
            .isoWeek(currentWeek)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + ++currentYear : "");
          let y = "0";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }
      return series;
    },       
    dateScope() {
      let dateScope = appCommons.allowedDateScope(
        "",
        120,
        "plus"
      );

      this.allowedDateScope = dateScope;
      let dateRange = {
        startDate: dateScope.startDate,
        endDate: dateScope.endDate
      }

      return dateRange;
    },
  },
  mounted() {
    this.init();
  },
  components: {
    vSelect,
    VueApexCharts,
    DemforCat
  }
};
</script>

<style lang="scss">

</style>
